<template>
<!-- 
xs(Extra Small)・・・主にスマホ対応
sm(Small)・・・主にタブレット
md(Medium) ・・・主にノートパソコンや横表示のタブレット
lg(Large)・・・主にデスクトップ
xl(Extra large)・・・4Kや大きなモニター 


v-if="$vuetify.breakpoint.xs"
-->
    <v-dialog v-if="isView" v-model="isView" persistent width="800">
        <v-card class="mt-3 pa-1">
            <v-card-title class="pa-0">
                <v-app-bar dense color="primary" dark elevation="0">
                    <v-list-item-title>
                        <!-- <v-icon>mdi-eye-circle</v-icon>                                                 -->
                        <span>作業</span>
                    </v-list-item-title>
                    <TitleButton
                        v-if="!readOnly"
                        @click="onClickSave"
                        color="primary"
                        icon="mdi-floppy"
                        name="保存" />
                    <TitleButton
                        color="primary"
                        icon="mdi-close-circle"
                        name="閉じる"
                        @click="isView = false" />
                </v-app-bar>
            </v-card-title>
            <v-card-text class="pa-0">
                <v-container fluid>
                    <v-form ref="form" >
                        <v-row >
                            <v-col cols="12">
                                <v-text-field
                                    v-model="editItems.name" 
                                    dense
                                    clearable 
                                    label="作業名"
                                    item-text="text"
                                    outlined
                                    hide-details />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                                <v-select 
                                    v-model="editItems.work.selectedWork"
                                    dense
                                    label="作業内容"
                                    outlined
                                    clearable
                                    :readonly="targetWork != null"
                                    :items="enabledWorkTypes"
                                    item-text="name"
                                    return-object
                                    hide-details
                                    @change="onSelectedWork" />
                            </v-col>
                            <!-- <v-col v-if="editItems.work.selectedWork != null && editItems.work.selectedWork.workTypeID == 0" cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                                <v-text-field
                                    v-model="editItems.work.workName" 
                                    dense
                                    clearable 
                                    label="新しい作業"
                                    item-text="text"
                                    outlined
                                    hint="登録されていない作業の時は、ここに入力します。"
                                    persistent-hint />
                            </v-col> -->
                            <v-col v-if="editItems.work.selectedWork == null" cols="12" xs="12" sm="6" md="6" lg="6" xl="6">
                                <v-text-field
                                    v-model="editItems.work.workName" 
                                    dense
                                    clearable 
                                    label="新しい作業"
                                    item-text="text"
                                    outlined
                                    hint="登録されていない作業の時は、ここに入力します。"
                                    persistent-hint />
                            </v-col>
                        </v-row>
                        <v-row align="baseline">
                            <v-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
                                <DatePicker 
                                    label="開始予定日"
                                    v-model="editItems.scheduleDate.startDate"
                                    dense
                                    icon=""
                                    :canEdit="!readOnly" />
                            </v-col>
                            <v-col cols="12" xs="12" sm="4" md="4" lg="4" xl="4">
                                <DatePicker 
                                    label="終了予定日"
                                    v-model="editItems.scheduleDate.endDate"
                                    icon=""
                                    dense
                                    :canEdit="!readOnly" />
                            </v-col>
                            <v-col v-if="targetWork != null" :class="$vuetify.breakpoint.xs ? 'pt-0' : ''">
                                <v-switch
                                    v-model="editItems.isCompleted"
                                    label="作業終了"
                                    hide-details
                                    dense />
                            </v-col>
                        </v-row>
                        <v-row >
                            <v-col>
                                <v-textarea
                                    v-model="editItems.memo"
                                    label="メモ"
                                    rows="2"
                                    outlined
                                    clearable
                                    auto-grow
                                    hide-details>
                                </v-textarea>
                            </v-col>
                        </v-row>
                        <!-- <v-row dense>
                            <v-col>
                                <ValueRegister
                                    :readOnly="false"
                                    :selectedWorkItem="getWorkType(editItems.work.selectedWork)"
                                    :recordValues="editItems.records"/>
                            </v-col>
                        </v-row> -->
                    </v-form>
                </v-container>
            </v-card-text>
        </v-card>
        <Confirm ref="confirm" />
    </v-dialog>
</template>
<script>
    import fb from '@/firebase/firebase.js'
    import db from '@/firebase/firestore.js'
    import Confirm from '@/components/tools/ConfirmDialog';
    import DatePicker from '@/components/tools/DatePicker';
    import TitleButton from '@/components/tools/TitleBarButton';
    export default {
        props: {
            readOnly: {
                type: Boolean, 
                default: false
            },
            states: {
                type: Array,
                default: []
            },
            workTypes: {
                type: Array,
                default: []
            },
        },
        components: {
            TitleButton,
            DatePicker,
            Confirm,
        },
        data: function () {
            return {
                isView: false,
                editItems: {
                    name: null,
                    scheduleDate: {
                        startDate: "",
                        endDate: ""
                    },
                    work: {
                        selectedWork: null,     // 選択された作業項目
                        workName: ""
                    },
                    memo: null,
                    isCompleted: false
                },
                targetWork: null,
                targetPlace: null,
            }
        },
        computed: {
            /**
             * 有効な作業、およびユーザーの追加した作業種類を格納した配列を返す(作業内容セレクターの項目)
             */
            enabledWorkTypes: function () {
                const list = []
                this.workTypes.forEach(function(workType){
                    if (workType.workTypeID > 100 || workType.enabled) {
                        list.push(workType)
                    }
                })
                return list
            }
        },
        methods: {
            /**
             * 作業内容選択時
             */
            onSelectedWork: function () {
                console.log("MaintenancePlaceWork", "onSelectedWork", this.editItems.work.selectedWork)
                if (this.editItems.work.selectedWork != null && this.editItems.work.selectedWork.workTypeID == 8 && !this.targetPlace.body.managementAgrichemical.enabled) {
                    this.$refs.confirm.show({
                        title: "農薬散布選択不可",
                        message: "この圃場では農薬管理が有効になっていないので<br/>選択することは出来ません。",
                        buttonYes: "戻る",
                        buttonNo: "",
                        width: 600,
                    })
                    const self = this
                    setTimeout(()=>self.editItems.work.selectedWork = null, 100)
                    
                }
            },
            /**
             * 保存ボタン押下時
             */
            onClickSave: function () {
                const self = this
                console.log("edit items", this.editItems)

                if (this.editItems.work.selectedWork == null && (this.editItems.work.workName == null || this.editItems.work.workName == "")){
                    this.$refs.confirm.show({
                        title: "作業の選択",
                        message: "作業内容を選択するか、新しい作業名を入力して下さい。",
                        buttonYes: "戻る",
                        buttonNo: "",
                        width: 600,
                    })
                    return
                }

                if (this.editItems.name == null || this.editItems.name == '') {
                    /** 作業名が未入力の時は、作業内容の名称にする */
                    if (this.editItems.work.selectedWork != null) {
                        this.editItems.name = this.editItems.work.selectedWork.name
                    } else {
                        this.editItems.name = this.editItems.work.workName
                    }
                }

                if (this.targetWork != null && this.targetWork.isCompleted == false && this.editItems.isCompleted) {
                    this.$refs.confirm.show({
                        title: "保存",
                        message: "作業終了が設定されました。<br/>登録すると、この作業に対して作業記録は行えなくなります。<br/>このまま登録しますか？",
                        buttonYes: "登録する",
                        buttonNo: "いいえ",
                        width: 600,
                        listenerYes: function () {
                            self.registWork()
                            return true
                        },
                    })
                } else {
                    this.$refs.confirm.show({
                        title: "保存",
                        message: "作業を登録しますか？",
                        buttonYes: "登録する",
                        buttonNo: "いいえ",
                        width: 400,
                        listenerYes: function () {
                            self.registWork()
                            return true
                        },
                    })
                }
            },
            /**
             * 作業の登録処理
             */
            registWork: function () {
                console.log(this.editItems)
                const userUID = this.$store.getters["userUID"]
                const self = this

                // 新しい作業項目
                var newWorkType = null

                if (this.editItems.work.selectedWork == null && this.editItems.work.workName.length > 0) {
                    // 新しい作業項目が指定されている時
                    var newID = 101

                    if (this.workTypes.length >= 1) {
                        newID = Math.max(...self.workTypes.map(m => m.workTypeID)) + 1
                        if (newID <= 100) newID = 101
                    }

                    newWorkType = {
                        version: "1.0.0",
                        workTypeID: newID,
                        name: this.editItems.work.workName,
                        recordItems: [],
                        register: {
                            userUID: this.$store.getters["loggedInUserUID"],
                            dateTime: this.df_currentDateTime()
                        },
                        updater: {
                            userUID: "",
                            dateTime: ""
                        }
                    }
                    this.editItems.work.selectedWork = newWorkType

                    console.log("new work", newWorkType)
                }

                // ======================
                // 作業を登録
                var work = null

                if (this.targetWork == null) {                    
                    work = {
                        version: "1.0.0",
                        placeID: this.targetPlace.body.placeID,
                        workID: this.df_currentDateTime("yyyyMMddHHmmss"),
                        name: "",
                        workTypeID: null,
                        scheduleDate: {
                            startDate: "",
                            endDate: ""
                        },
                        recordInformation: {
                            firstDate: "",
                            lastDate: ""
                        },
                        isCompleted: false,
                        records: null,
                        memo: "",
                        register: {
                            userUID: this.$store.getters["loggedInUserUID"],
                            dateTime: this.df_currentDateTime()
                        },
                        updater: {
                            userUID: "",
                            dateTime: ""
                        }
                    }
                } else {
                    work = this.targetWork
                    work.updater = {
                        userUID: this.$store.getters["loggedInUserUID"],
                        dateTime: this.df_currentDateTime()
                    }
                }

                work.workTypeID = this.editItems.work.selectedWork.workTypeID
                work.name = this.editItems.name
                work.scheduleDate.startDate = this.editItems.scheduleDate.startDate
                work.scheduleDate.endDate = this.editItems.scheduleDate.endDate
                work.isCompleted = this.editItems.isCompleted
                work.memo = this.editItems.memo

                console.log(work)

                var batch = db.batch()

                batch.set(db.collection("users").doc(userUID)
                          .collection("places").doc(""+this.targetPlace.body.placeID)
                          .collection("works").doc(work.workID), work)

                // ======================
                // 新しい作業項目を登録
                if (newWorkType != null) {
                    console.log("新しい作業項目を登録(start)", newWorkType, this.workTypes)
                    batch.set(db.collection("users").doc(userUID)
                                .collection("places").doc(""+this.targetPlace.body.placeID)
                                .collection("place_work_types").doc(""+newWorkType.workTypeID),
                                newWorkType)

                    this.workTypes.push(newWorkType)
                    this.targetPlace.userWorkTypes.push(newWorkType)

                    console.log("新しい作業項目を登録(completed)", newWorkType, this.workTypes)
                }

                // ======================
                // コミット
                try{
                    batch.commit().then(function(){
                        self.$store.commit("notification", {message:"作業を登録しました。", isError:false})
                        
                        // 監視ロジック側で配列に追加する為、ここのロジックは削除
                        // if (self.targetWork == null) {
                        //     self.targetPlace.works.push(work)
                        // }

                        self.$emit("onUpdatedTargetPlaceWork", work)
                        self.isView = false
                    }).catch (function(error) {
                        console.log(error)
                        self.$store.commit("notification", {message:"作業の登録に失敗しました。", isError:true})
                    })
                } catch (error) {
                    console.log(error)
                    self.$store.commit("notification", {message:"作業の登録に失敗しました。", isError:true})
                }
            },
            show: function (place, work) {
                console.log("show", place, work)
                const self = this

                this.targetPlace = place
                this.targetWork = work
                this.isView = true

                if (this.targetWork == null) {
                    this.editItems.name = ""
                    this.editItems.scheduleDate.startDate = ""
                    this.editItems.scheduleDate.endDate = ""
                    this.editItems.work.selectedWork = null
                    this.editItems.work.workName = ""
                    this.editItems.isCompleted = false
                    this.editItems.memo = ""
                } else {
                    this.editItems.name = this.targetWork.name
                    this.editItems.scheduleDate.startDate = this.targetWork.scheduleDate.startDate
                    this.editItems.scheduleDate.endDate = this.targetWork.scheduleDate.endDate
                    this.editItems.work.selectedWork = this.getWorkType(this.targetWork.workTypeID)
                    this.editItems.work.workName = ""
                    this.editItems.isCompleted = this.targetWork.isCompleted
                    this.editItems.memo = this.targetWork.memo
                }
                console.log(this.editItems)
            },
            getWorkType: function (id) {
                // console.log("workItem", id)
                return this.workTypes[this.workTypes.findIndex((v)=>v.workTypeID == id)]
            },
        }
    }
</script>
